import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/entry-values")({
    beforeLoad: () => {
        throw redirect({ to: "/design/components/entry-values", replace: true });
    },
});
